import React from 'react';
import './PortfolioTable.css';

const PortfolioTable = ({columns, entities}) => {
    return (
        <table className="portfolio__table">
            <thead>
                <tr>
                    {columns?.map((column,i) => (
                        <th key={i}>{column}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {
                    entities?.map((entity, i) => (
                        <tr key={`stockRow-${i}`}>
                            {entity.map((column, i) => (
                                <td key={`stockValue-${i}`}>{column}</td>
                            ))}
                        </tr>
                    ))
                }
            </tbody>
        </table>
    )
}

export default PortfolioTable
